import { Breakpoints, Shape } from '@mui/system';

export const FONT_FAMILY = 'GeneralSans-Variable';

export const BREAKPOINTS: Breakpoints['values'] = {
  xs: 0,
  sm: 840,
  md: 1080,
  lg: 1280,
  xl: 1440,
};

export const SPACING = 4;

export const SHAPE: Shape = {
  borderRadius: 18,
};
